import { StateType } from './context';
import { Notification } from '../interfaces/api/Notifications';
export enum Types {
  SetBreadcrumb = 'SET_BREADCRUMB',
  SetActiveChannels = 'SET_ACTIVECHANNELS'
}

export type BreadcrumbActions = {
  type: Types.SetBreadcrumb;
  payload: {
    breadcrumbNotificationName: string;
  };
};
export type ActiveChannelsActions = {
  type: Types.SetActiveChannels;
  payload: {
    activeChannels: Notification['channels'];
  };
};

export const breadcrumbReducer = (
  state: StateType,
  action: BreadcrumbActions
): StateType => {
  switch (action.type) {
    case Types.SetBreadcrumb:
      return {
        ...state,
        breadcrumbNotificationName: action.payload.breadcrumbNotificationName
      };

    default:
      return state;
  }
};
export const activeChannelsReducer = (
  state: StateType,
  action: ActiveChannelsActions
): StateType => {
  switch (action.type) {
    case Types.SetActiveChannels:
      return {
        ...state,
        activeChannels: action.payload.activeChannels
      };

    default:
      return state;
  }
};
